/**
 * Formats a patient name for display purposes
 */
export default function formatPN(name) {
  if (!name) {
    return;
  }

  let nameToUse = name.Alphabetic ?? name;
  if (typeof nameToUse === 'object') {
    nameToUse = '';
  }

  const components = nameToUse.split('^').map(component => component.trim());
  const [familyName, givenName, ...remainingComponents] = components;
  const formattedPrimaryName =
    familyName && givenName ? `${familyName}, ${givenName}` : familyName || givenName;

  // Prefix, middle name and suffix components are separated by spaces. Empty
  // DICOM PN components are omitted rather than producing stray punctuation.
  return [formattedPrimaryName, ...remainingComponents].filter(Boolean).join(' ');
}
